const NetPriceFilters = {
    install (Vue, options) {
        Vue.filter('netPrice', function (quantity, grossPrice, vatPercentage) {
            parseFloat(calculateNetPrice(quantity, grossPrice, vatPercentage)).toFixed(2);
        })

        function calculateNetPrice(vatPercentage, grossPrice, quantity)
        {
            return ((vatPercentage / 100) + 1) * (grossPrice * quantity)
        }

    }
}

export default NetPriceFilters